/* import flipkart_logo from "../assets/flipkartLogo.svg";
import amazon_logo from "../assets/amazon_logo2.svg";
import croma_logo from "../assets/croma_logo.svg";
import jiomart_logo from "../assets/jiomart-logo.svg";
import reliance_logo from "../assets/reliancedigital-logo.svg";
import moglix_logo from "../assets/moglix_logo.png";
import bewakoof_logo from "../assets/bewakoof_logo.png";
import clarion_logo from "../assets/clarion_logo.png";
import elitehubs_logo from "../assets/elitehubs_logo.png";
import mdcomputers_logo from "../assets/mdcomputers_logo.png";
import pcstudio_logo from "../assets/pcstudio_logo.png";
import shumee_logo from "../assets/shumee_logo.png";
import toyroom_logo from "../assets/bewakoof_logo.png";

import flipkart_initial from "../assets/flipkart-initial.svg";
import amazon_initial from "../assets/amazon_initial.svg";
import croma_initial from "../assets/croma-initial.svg";
import jiomart_initial from "../assets/jiomart-initial.svg";
import moglix_initial from "../assets/moglix_initial.png";
import bewakoof_initial from "../assets/bewakoof_initial.png";
import elitehubs_initial from "../assets/elitehubs_initial.png";
import mdcomputers_initial from "../assets/mdcomputers_initial.png";
import shumee_initial from "../assets/shumee_initial.png"; */

import default_logo from "../assets/default_logo_retailor.png";
import { serviceFetchRetailerLogo } from "src/api/service/services";

export interface Retailer {
  id: number;
  retailer_name: string;
  retailer_value: string;
  retailer_logo: string;
  retailer_initial: string;
}

/* export const retailers: Retailer[] = [
  {
    id: 1,
    retailer_name: "Flipkart",
    retailer_value: "FLIPKART",
    retailer_logo: flipkart_logo,
    retailer_initial: flipkart_initial,
  },
  {
    id: 2,
    retailer_name: "Amazon",
    retailer_value: "AMAZON",
    retailer_logo: amazon_logo,
    retailer_initial: amazon_initial,
  },
  {
    id: 3,
    retailer_name: "Croma",
    retailer_value: "CROMA",
    retailer_logo: croma_logo,
    retailer_initial: croma_initial,
  },
  {
    id: 4,
    retailer_name: "Jiomart",
    retailer_value: "JIOMART",
    retailer_logo: jiomart_logo,
    retailer_initial: jiomart_initial,
  },
  {
    id: 5,
    retailer_name: "Reliance Digital",
    retailer_value: "RELIANCE_DIGITAL",
    retailer_logo: reliance_logo,
    retailer_initial: reliance_logo,
  },
  {
    id: 5,
    retailer_name: "Moglix",
    retailer_value: "MOGLIX",
    retailer_logo: moglix_logo,
    retailer_initial: moglix_initial,
  },
  {
    id: 6,
    retailer_name: "Bewakoof",
    retailer_value: "BEWAKOOF",
    retailer_logo: bewakoof_logo,
    retailer_initial: bewakoof_initial,
  },
  {
    id: 7,
    retailer_name: "Clarion",
    retailer_value: "CLARION",
    retailer_logo: clarion_logo,
    retailer_initial: clarion_logo,
  },
  {
    id: 8,
    retailer_name: "Elitehubs",
    retailer_value: "ELITEHUBS",
    retailer_logo: elitehubs_logo,
    retailer_initial: elitehubs_initial,
  },
  {
    id: 9,
    retailer_name: "Md Computers",
    retailer_value: "MDCOMPUTERS",
    retailer_logo: mdcomputers_logo,
    retailer_initial: mdcomputers_initial,
  },
  {
    id: 10,
    retailer_name: "PC Studio",
    retailer_value: "PCSTUDIO",
    retailer_logo: pcstudio_logo,
    retailer_initial: pcstudio_logo,
  },
  {
    id: 11,
    retailer_name: "Shumee",
    retailer_value: "SHUMEE",
    retailer_logo: shumee_logo,
    retailer_initial: shumee_initial,
  },
  {
    id: 12,
    retailer_name: "Toy Room",
    retailer_value: "TOYROOM",
    retailer_logo: toyroom_logo,
    retailer_initial: toyroom_logo,
  },
]; */

export const retailersPromise: Promise<Retailer[]> =
  serviceFetchRetailerLogo().then((res) => {
    const data = res?.data;
    console.log(data)
    if (Array.isArray(data)) {
          console.log(data)
      return data;
    }

    if (Array.isArray(data?.data)) {
          console.log(data.data)

      return data.data;
    }

    if (Array.isArray(data?.results)) {
                console.log(data.results)

      return data.results;
    }

    console.error("Unexpected retailer API response shape:", data);
    return [];
  });


// Create a map for fast lookup
export const retailerLogoMap: Record<string, string> = {};

export const retailerInitialMap: Record<string, string> = {};

// Build maps once data is available
retailersPromise.then((retailers) => {
  retailers.forEach((r) => {
    retailerLogoMap[r.retailer_value] = r.retailer_logo;
    retailerInitialMap[r.retailer_value] = r.retailer_initial;
  });
});


export const getRetailerLogo = (name: string): string => {
  return retailerLogoMap[name] || default_logo;
};

export const getRetailerInitial = (name: string): string => {
  return retailerInitialMap[name] || default_logo;
};
